
export const ADD_PENDING    = 'ADD_PENDING'
export const ADD_REQUEST    = 'ADD_REQUEST'
export const RESET_DRAFT    = 'RESET_DRAFT'
export const REMOVE         = 'REMOVE'
export const REMOVE_PENDING = 'REMOVE_PENDING'
export const REMOVE_REQUEST = 'REMOVE_REQUEST'
export const REPLACE_DRAFT  = 'REPLACE_DRAFT'
export const SET_MANY       = 'SET_MANY'
export const SET_COUNTS     = 'SET_COUNTS'
export const SET_ONE        = 'SET_ONE'
